import React, { Component } from 'react';
import { Input, Select } from 'antd';
import SymbolText from './SymbolText';
import Field from './Field';

const { Option } = Select;

class InvestigationName extends Component {
    handleChange = (value, key) => {
        const { data, index, onChange } = this.props;
        switch(key) {
            case 'responsibleFieldId':
                const { symbol, id } = data;
                onChange({
                    id,
                    symbol,
                    responsibleFieldId: value,
                }, index);
                return;
            default:
                data[key] = value;
                break;
        }
        onChange(data, index);
    }

    render() {
        const { data, fieldList, rangeList } = this.props;
        const { symbol, responsibleFieldId, range, text } = data;
        const rangeOption = rangeList.map(i => <Option key={i.investigationTypeId}>{i.investigationTypeName}</Option>);
        return (
            <div>
                <SymbolText symbol={symbol} />
                <div className="border">
                    <Field value={responsibleFieldId} list={fieldList} onChange={this.handleChange} />
                    <Select
                        value={range}
                        placeholder="请选择"
                        style={{ width: 70, margin: '0 10px' }}
                        onChange={(value) => this.handleChange(value, 'range')}
                    >
                        {rangeOption}
                    </Select>
                    <Input value={text} style={{width: 180}} placeholder="请输入" onChange={(e) => this.handleChange(e.target.value, 'text')} />
                </div>
            </div>
        );
    }
}

export default InvestigationName;



// WEBPACK FOOTER //
// ./src/components/user/fieldLeader/components/InvestigationName.js